// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2bQ0C","leftSlide":"styles_leftSlide__1mtIw","rightSlide":"styles_rightSlide__J0bPd"};